import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@webrcade/app-common/dist/index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
